import { createContext } from 'preact';

interface GarageContext {
  closeGarage?: () => void;
  doNotRedirectOnVehicleSelect?: boolean;
  isAutoVehicleSelectionDisabled?: boolean;
  isShowVehicleDropdowns?: boolean;
  redirectUrl?: string;
  showVehicleDropdowns?: () => void;
  useNativeDropdown?: boolean;
  useVehicleWidget?: boolean;
  isVehicleSelected?: boolean;
  discardSelectedVehicle?: () => void;
  vehicle?: Record<string, string>;
  columnBreakpoint?: number | string;
}

export default createContext<GarageContext>({});
